
    import Vue from "vue";

    import UnitPlanOa from "../../store/planner/objetive/UnitPlanOa";
    import {orderBy} from "lodash";
    import UnitPlanComments from '../../store/units/UnitPlanComments';
    // Components
    import RomaMessageModal from '../commons/RomaMessageModal.vue';

    export default Vue.extend({
  name: "RomaAdvance",
  async created() {
    this.loading = true;
    const request = new URLSearchParams(`idPlanUnidad=${this.unit.id}`);
    await this.$store.dispatch("romaOAsBySubjectId", request).then(response => {
      UnitPlanOa.insertOrUpdate({ data: response.data.content });
    });

    await this.$store.dispatch("getUnitPlanWeeks", this.unit.id).then(response => {

      this.unitplan_weeks = response.data.content
        .flatMap((month: any) => month.semanas)
        .filter((week: any) => week.planUnidadSemanaItemToList.length > 0)
        .map((week: any) => {
          const OAs = UnitPlanOa.query()
                        .where('disabled', false)
                        .where('rescheduled', false)
                        .whereIdIn(week.planUnidadSemanaItemToList.map((item: any) => item.idPlanUnidadOA))
                        .with('oa', queryOA => {
                          queryOA.with('ies', queryIE => {
                            queryIE
                              .where('disabled', false)
                              .where('rescheduled', false)
                              .whereIdIn(week.planUnidadSemanaItemToList.filter((item: any) => item.ie_id > 0).map((item: any) => item.ie_id))
                              .orderBy('cod');
                            });
                        })
                        .get();
          OAs.forEach((puOA: any) => {
            puOA.oa.ies = puOA.oa.ies.map((ie: any) =>
              Object.assign({}, ie, {
                done: week.planUnidadSemanaItemToList.find((item: any) => item.ie_id === ie.id).estadoRealizado === 3,
                idPlanUnidadSemana: week.id,
              })
            );
          });
          week.oas = orderBy(OAs, ['oa.cod']);
          return week;
        });
    });
    this.loading = false;
    const today = (new Date()).toISOString().substr(0, 10);
    const weekToExpand = this.unitplan_weeks.find((week: any) => today >= week.fechaInicio.substr(0, 10) && today <= week.fechafin.substr(0, 10));
    // @ts-ignore
    if (weekToExpand) this.expandedWeeks = [weekToExpand];
  },
  props: {
    unit: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: "514"
    },
    applyRowColor: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expandedWeeks: [],
      messageDialog: false,
      filterBy: {
        field: '',
        value: 0,
      },
      parcialRequest: {
        idPlanUnidadOA: 0,
        idPlanUnidad: 0,
      },
      loading: false,
      unitplan_weeks: [],
      request: null, // modificación del ie
      headers: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" }
      ],
      oaDetails: [
        {
          name: "reprogramar",
          icon: "fas fa-calendar-times",
          onClick: (item: any) => {
            this.reprogramOA(item);
          },
          enable: this.$store.state.user.privileges
            .canSeeUnitCoverageAndActivities
        },
        {
          name: "comentarios",
          icon: "fas fa-comment",
          color: "primary",
          count: (item: any) => {
            return UnitPlanComments.query().where('idPlanUnidadOA', item.id).count();
          },
          onClick: (item: any) => {
            this.messageDialog = true;
            this.parcialRequest = {
              idPlanUnidadOA: item.id,
              idPlanUnidad: this.unit.id,
            };
            this.filterBy = {
              field: 'idPlanUnidadOA',
              value: item.id,
            };
          },
          enable: this.$store.state.user.privileges.canSeeComments,
        }
      ],
    };
  },
  methods: {
    async reprogramOA(item: any) {
      this.loading = true;

      let toggleOATOList: any[] = [];
      let IEIds: number[] = [];

      const toggle: any = {
        toggleOATOList: [
          {
            idPlanUnidadOA: item.id,
            changeStatus: true
          }
        ],
        ieids: [],
        reprogram: true,
        dontChangeStatus: true,
      };

      const response = await this.$store.dispatch("toggleUnitPlanOA", toggle);
      let msj = {
        show: true,
        text: "",
        color: "success"
      };
      if (
        response.data &&
        response.data.status &&
        response.data.status.code === 1
      ) {
        msj.text = "Objetivo reprogramado";
        this.unitplan_weeks.forEach((week: any) => {
          const indexOfItemReprogramed: any = week.oas.findIndex((oa: any) => oa.id === item.id);
          if (indexOfItemReprogramed >= 0) week.oas.splice(indexOfItemReprogramed, 1);
        });

        this.unitplan_weeks = this.unitplan_weeks.filter((week: any) => week.oas.length > 0);

        if (this.unitplan_weeks.length <= 0) {
          window.location.href = "/organizer";
          alert("No se tienen items planificados");
        }
        this.unit.updatePercentages(response.data.content.percentages);
      } else if (
        response.data &&
        response.data.status &&
        response.data.status.code === 3
      ) {
        msj.text = response.data.content.message;
        msj.color = "red";
      } else {
        msj.text = "No se pudo procesar su solicitud";
        msj.color = "red";
      }

      this.$store.state.snackbar = msj;

      this.loading = false;
    },
    hoursInWeek(puOA: any, week: any): number {
      const itemWithHours: any = week.planUnidadSemanaItemToList.find((item: any) => item.idPlanUnidadOA === puOA.id && item.tipo === 0 && Number.isInteger(Number.parseInt(item.horas)));
      return itemWithHours ? itemWithHours.horas : 0;
    },
    async saveAdvance() {
      this.loading = true;
      const msj = {
        show: true,
        text: "¡Avance de la unidad Guardada!",
        color: "success"
      };

      const items: any[] = this.unitplan_weeks.flatMap((week: any) => week.planUnidadSemanaItemToList);

      const request: any = {
        idPlanUnidad: this.unit.id,
        planUnidadSemanaItemTOList: this.unitplan_weeks
          .flatMap((week: any) => week.oas)
          .flatMap(puOA => puOA.oa)
          .flatMap(oa => oa.ies)
          .flatMap(ie => {
            const item = items.find(item => item.ie_id === ie.id && item.idPlanUnidadSemana === ie.idPlanUnidadSemana);
            if (!!item) {
              return {
                id: item.id,
                estadoRealizado: ie.done ? 3 : item.estadoRealizado,
              };
            } else {
              return {
                id: 0,
              };
            }
          })
          .filter(item => item.id > 0),
      };

      const response = await this.$store.dispatch('setUnitPlanWeeksAdvance', request);

      if (response.data && response.data.status && response.data.status.code === 1) {
        this.unit.updateStatus(response.data.content.status);
        this.unit.updatePercentages(response.data.content.percentages);
        if (response.data.content.comment) UnitPlanComments.insert({ data: response.data.content.comment });
      } else if (response.data && response.data.status && response.data.status.code === 3) {
        msj.color = 'red';
        msj.text = response.data.content.message;
      } else {
        msj.color = 'red';
        msj.text = 'No se pudo registrar el avance';
      }

      this.$store.state.snackbar = msj;
      this.loading = false;
    },
    advanceOa(ies: any[]) {
      const dones = ies.filter(ie => ie.done);
      return ies.length > 0 ? ((100 * dones.length) / ies.length).toFixed(0) : 0;
    },
    rowStyle(itemIndex: number, disabled: boolean) {
      const colors = [
        "--v-roma_rcolor-base",
        "--v-primary-base",
        "--v-secondary-base",
        "--v-roma_acolor-base"
      ];
      let color = colors[itemIndex];
      color = `var(${colors[itemIndex % colors.length]})`;

      if (disabled || !this.applyRowColor) color = "grey";

      return `border-left: 8px solid ${color};`;
    }
  },
  components: {
    RomaMessageModal,
  }
});
